var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      (!_vm.isHasForecastOrg && !_vm.isHasDropshippingOrg) || !_vm.isTenant
        ? _c("v-layout", { staticClass: "headline" }, [
            _vm._v(
              _vm._s(
                !_vm.isHasForecastOrg && !_vm.isHasDropshippingOrg
                  ? _vm.$t("tenantPublicBaseRates")
                  : _vm.$t("publicBaseRates")
              )
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.displayMode
        ? _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { md2: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "edit",
                      attrs: { color: "primary" },
                      on: { click: _vm.showBillingBaseRatesDialog }
                    },
                    [_vm._v(_vm._s(_vm.$t("edit")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      (!_vm.isHasForecastOrg && !_vm.isHasDropshippingOrg) || !_vm.isTenant
        ? _c(
            "v-layout",
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-container",
                            { attrs: { fluid: "", "grid-list-lg": "" } },
                            _vm._l(_vm.unitRates, function(item) {
                              return _c(
                                "v-layout",
                                {
                                  key: item.sortKey,
                                  attrs: { "justify-space-between": "" }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "subheading",
                                      attrs: { md2: "" }
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-right",
                                      attrs: { md3: "" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("inboundPerPackage")) +
                                          ": "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-left",
                                      attrs: { md1: "" }
                                    },
                                    [
                                      _vm._v(
                                        "$ " + _vm._s(item.packageInbound || 0)
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass:
                                        "text-xs-right text-capitalize",
                                      attrs: { md3: "" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("itemInboundPerUnit")) +
                                          ":"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-left",
                                      attrs: { md1: "" }
                                    },
                                    [_vm._v("$ " + _vm._s(item.inbound))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-right",
                                      attrs: { md3: "" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("outboundPerPackage")) +
                                          ":"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-left",
                                      attrs: { md1: "" }
                                    },
                                    [
                                      _vm._v(
                                        "$ " + _vm._s(item.packageOutbound || 0)
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass:
                                        "text-xs-right text-capitalize",
                                      attrs: { md3: "" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("itemOutboundPerUnit")) +
                                          ":"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-left",
                                      attrs: { md1: "" }
                                    },
                                    [_vm._v("$ " + _vm._s(item.outbound))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass:
                                        "text-xs-right text-capitalize",
                                      attrs: { md3: "" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("itemStorageDaily")) + ":"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-left",
                                      attrs: { md1: "" }
                                    },
                                    [_vm._v("$ " + _vm._s(item.storage))]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isHasForecastOrg || !_vm.isTenant
        ? _c(
            "v-layout",
            { staticClass: "headline", attrs: { headline: "", "mt-5": "" } },
            [
              _vm._v(
                _vm._s(
                  _vm.isHasForecastOrg
                    ? _vm.$t("tenantPublicBaseRates")
                    : _vm.$t("PublicForecastBaseRates")
                )
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.displayMode
        ? _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { md2: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "edit",
                      attrs: { color: "primary" },
                      on: { click: _vm.showBillingForecastBaseRatesDialog }
                    },
                    [_vm._v(_vm._s(_vm.$t("edit")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isHasForecastOrg || !_vm.isTenant
        ? _c(
            "v-layout",
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-container",
                            { attrs: { fluid: "", "grid-list-lg": "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { "justify-space-between": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-right",
                                      attrs: { md3: "" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("inboundPerPackage")) +
                                          ": "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-left",
                                      attrs: { md1: "" }
                                    },
                                    [
                                      _vm._v(
                                        "$ " +
                                          _vm._s(
                                            _vm.forecastUnitRates
                                              .packageInbound || 0
                                          )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-right",
                                      attrs: { md3: "" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("outboundPerPackage")) +
                                          ": "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-left",
                                      attrs: { md1: "" }
                                    },
                                    [
                                      _vm._v(
                                        "$ " +
                                          _vm._s(
                                            _vm.forecastUnitRates
                                              .packageOutbound || 0
                                          )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-right",
                                      attrs: { md3: "" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("dailyStoragePerUnit")) +
                                          ": "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-left",
                                      attrs: { md1: "" }
                                    },
                                    [
                                      _vm._v(
                                        "$ " +
                                          _vm._s(
                                            _vm.forecastUnitRates.storage || 0
                                          )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { "justify-space-between": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-right",
                                      attrs: { md3: "" }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("unitFee")) + ": ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-left",
                                      attrs: { md1: "" }
                                    },
                                    [
                                      _vm._v(
                                        "$ " +
                                          _vm._s(
                                            _vm.forecastUnitRates.unitFee || 0
                                          )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-right",
                                      attrs: { md3: "" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("unpackingMinimumFee")) +
                                          ": "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-xs-left",
                                      attrs: { md1: "" }
                                    },
                                    [
                                      _vm._v(
                                        "$ " +
                                          _vm._s(
                                            _vm.forecastUnitRates
                                              .unpackingMinimumFee || 0
                                          )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { md4: "" } })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.displayMode
        ? _c(
            "div",
            [
              _c("v-layout", { staticClass: "headline mt-5" }, [
                _vm._v(_vm._s(_vm.$t("discountSchedule")))
              ]),
              _vm._v(" "),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "add",
                          attrs: { dark: "", color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.showEditDiscountDialog({})
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("add")))]
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        staticClass: "elevation-2 myDense",
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.tierDiscounts,
                          "item-key": "reportKey",
                          pagination: _vm.pagination
                        },
                        on: {
                          "update:pagination": function($event) {
                            _vm.pagination = $event
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "items",
                              fn: function(props) {
                                return [
                                  _c("td", { staticClass: "subheading" }, [
                                    _vm._v(_vm._s(props.item.name))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "subheading" }, [
                                    _vm._v(_vm._s(props.item.threshold))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-xs-left" }, [
                                    _vm._v(_vm._s(props.item.discountRate))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "text-xs-center" },
                                    [
                                      _c(
                                        "v-layout",
                                        [
                                          _c(
                                            "v-flex",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    dark: "",
                                                    color: "primary",
                                                    flat: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.showEditDiscountDialog(
                                                        props.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(_vm.$t("edit")))]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    dark: "",
                                                    color: "secondary",
                                                    flat: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.deleteDiscount(
                                                        props.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("delete"))
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2128955739
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isHasDropshippingOrg || !_vm.isTenant
        ? _c(
            "div",
            [
              _c("v-layout", { staticClass: "headline mt-5" }, [
                _vm._v(_vm._s(_vm.$t("dailyStoragePerUnitDropshipping")))
              ]),
              _vm._v(" "),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    [
                      !_vm.displayMode
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "add",
                              attrs: { dark: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.showStoragePricing()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("edit")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-container",
                                    {
                                      attrs: { fluid: "", "grid-list-lg": "" }
                                    },
                                    _vm._l(_vm.storageWeightScope, function(
                                      item
                                    ) {
                                      return _c(
                                        "v-layout",
                                        {
                                          key: item.sortKey,
                                          attrs: { "justify-space-between": "" }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-xs-right",
                                              attrs: { md3: "" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("startDay")) +
                                                  ": "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-xs-left",
                                              attrs: { md1: "" }
                                            },
                                            [_vm._v(_vm._s(item.start || 0))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-xs-right",
                                              attrs: { md1: "" }
                                            },
                                            [_c("span", [_vm._v("<   X   ≤")])]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass:
                                                "text-xs-right text-capitalize",
                                              attrs: { md3: "" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("endDay")) + ":"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-xs-left",
                                              attrs: { md1: "" }
                                            },
                                            [_vm._v(_vm._s(item.end))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(tooltip) {
                                                      return [
                                                        _c(
                                                          "v-flex",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "text-xs-right",
                                                              attrs: { md1: "" }
                                                            },
                                                            tooltip.on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t("price")
                                                              ) + ":"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t("unitCubicInchHint")
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-xs-left",
                                              attrs: { md2: "" }
                                            },
                                            [
                                              _vm._v(
                                                "$ " + _vm._s(item.price || 0)
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isShowStoragePricing
                    ? _c("StageStorageFeePopup", {
                        attrs: {
                          detail: _vm.storageWeightScope,
                          title: _vm.$t("dailyStoragePerUnitDropshipping"),
                          submit: _vm.onStoragePricingSubmitted
                        },
                        model: {
                          value: _vm.isShowStoragePricing,
                          callback: function($$v) {
                            _vm.isShowStoragePricing = $$v
                          },
                          expression: "isShowStoragePricing"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isHasDropshippingOrg || !_vm.isTenant
        ? _c(
            "div",
            [
              _c("v-layout", { staticClass: "headline mt-5" }, [
                _vm._v(_vm._s(_vm.$t("inboundPkgFeeForDropshipping")))
              ]),
              _vm._v(" "),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    [
                      !_vm.displayMode
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "add",
                              attrs: { dark: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.showInboundWeightFeeSettingPopup()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("edit")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-container",
                                    {
                                      attrs: { fluid: "", "grid-list-lg": "" }
                                    },
                                    [
                                      _vm._l(_vm.inboundWeightScope, function(
                                        item
                                      ) {
                                        return _c(
                                          "v-layout",
                                          {
                                            key: item.sortKey,
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "text-xs-right",
                                                attrs: { md3: "" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("start") +
                                                      "('weight')"
                                                  ) + ": "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "text-xs-left",
                                                attrs: { md1: "" }
                                              },
                                              [_vm._v(_vm._s(item.start || 0))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "text-xs-right",
                                                attrs: { md1: "" }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("<   X   ≤")
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass:
                                                  "text-xs-right text-capitalize",
                                                attrs: { md3: "" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("end") + "('weight')"
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "text-xs-left",
                                                attrs: { md1: "" }
                                              },
                                              [_vm._v(_vm._s(item.end))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: { top: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(tooltip) {
                                                        return [
                                                          _c(
                                                            "v-flex",
                                                            _vm._g(
                                                              {
                                                                staticClass:
                                                                  "text-xs-right",
                                                                attrs: {
                                                                  md3: ""
                                                                }
                                                              },
                                                              tooltip.on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "price"
                                                                  )
                                                                ) + ":"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.$t("unitCLbHint")
                                                    ) +
                                                    "\n              "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "text-xs-left",
                                                attrs: { md1: "" }
                                              },
                                              [
                                                _vm._v(
                                                  "$ " + _vm._s(item.price || 0)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass:
                                                  "text-xs-right text-capitalize",
                                                attrs: { md3: "" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    "" +
                                                      _vm.$t("secondItemPrice")
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "text-xs-left",
                                                attrs: { md1: "" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.secondItemPrice || 0
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-xs-right",
                                              attrs: { md3: "" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "overSizeChargePrice"
                                                  ) + "('weight')"
                                                ) + ": "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-xs-left",
                                              attrs: { md1: "" }
                                            },
                                            [
                                              _vm._v(
                                                "$ " +
                                                  _vm._s(
                                                    (_vm.inboundWeightScope[
                                                      _vm.inboundWeightScope
                                                        .length - 1
                                                    ] &&
                                                      _vm.inboundWeightScope[
                                                        _vm.inboundWeightScope
                                                          .length - 1
                                                      ].overSizeChargePrice) ||
                                                      0
                                                  )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isShowInboundWeightFeeSettingPopup
                    ? _c("WeightFeeSettingPopup", {
                        attrs: {
                          title: _vm.$t("inboundPkgFeeForDropshipping"),
                          detail: _vm.inboundWeightScope,
                          feeType: "inbound",
                          submit: _vm.onInboundWeightFeeSubmitted
                        },
                        model: {
                          value: _vm.isShowInboundWeightFeeSettingPopup,
                          callback: function($$v) {
                            _vm.isShowInboundWeightFeeSettingPopup = $$v
                          },
                          expression: "isShowInboundWeightFeeSettingPopup"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isHasDropshippingOrg || !_vm.isTenant
        ? _c(
            "div",
            [
              _c("v-layout", { staticClass: "headline mt-5" }, [
                _vm._v(_vm._s(_vm.$t("outboundPkgFeeForDropshipping")))
              ]),
              _vm._v(" "),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    [
                      !_vm.displayMode
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "add",
                              attrs: { dark: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.showOutboundWeightFeeSettingPopup()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("edit")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-container",
                                    {
                                      attrs: { fluid: "", "grid-list-lg": "" }
                                    },
                                    [
                                      _vm._l(_vm.outboundWeightScope, function(
                                        item
                                      ) {
                                        return _c(
                                          "v-layout",
                                          {
                                            key: item.sortKey,
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "text-xs-right",
                                                attrs: { md2: "" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("start") +
                                                      "('weight')"
                                                  ) + ": "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "text-xs-left",
                                                attrs: { md1: "" }
                                              },
                                              [_vm._v(_vm._s(item.start || 0))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "text-xs-right",
                                                attrs: { md1: "" }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("<   X   ≤")
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass:
                                                  "text-xs-right text-capitalize",
                                                attrs: { md2: "" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("end") + "('weight')"
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "text-xs-left",
                                                attrs: { md1: "" }
                                              },
                                              [_vm._v(_vm._s(item.end))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: { top: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(tooltip) {
                                                        return [
                                                          _c(
                                                            "v-flex",
                                                            _vm._g(
                                                              {
                                                                staticClass:
                                                                  "text-xs-right",
                                                                attrs: {
                                                                  md1: ""
                                                                }
                                                              },
                                                              tooltip.on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "price"
                                                                  )
                                                                ) + ":"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.$t("unitCLbHint")
                                                    ) +
                                                    "\n              "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "text-xs-left",
                                                attrs: { md1: "" }
                                              },
                                              [
                                                _vm._v(
                                                  "$ " + _vm._s(item.price || 0)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass:
                                                  "text-xs-right text-capitalize",
                                                attrs: { md3: "" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    "" +
                                                      _vm.$t("secondItemPrice")
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "text-xs-left",
                                                attrs: { md1: "" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.secondItemPrice || 0
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass:
                                                  "text-xs-right text-capitalize",
                                                attrs: { md3: "" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    "" +
                                                      _vm.$t(
                                                        "subsequentUPCFirstPrice"
                                                      )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "text-xs-left",
                                                attrs: { md1: "" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.secondProductPrice || 0
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-xs-right",
                                              attrs: { md3: "" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "overSizeChargePrice"
                                                  ) + "('weight')"
                                                ) + ": "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-xs-left",
                                              attrs: { md1: "" }
                                            },
                                            [
                                              _vm._v(
                                                "$ " +
                                                  _vm._s(
                                                    (_vm.outboundWeightScope[
                                                      _vm.outboundWeightScope
                                                        .length - 1
                                                    ] &&
                                                      _vm.outboundWeightScope[
                                                        _vm.outboundWeightScope
                                                          .length - 1
                                                      ].overSizeChargePrice) ||
                                                      0
                                                  )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isShowOutboundWeightFeeSettingPopup
                    ? _c("WeightFeeSettingPopup", {
                        attrs: {
                          title: _vm.$t("outboundPkgFeeForDropshipping"),
                          detail: _vm.outboundWeightScope,
                          feeType: "outbound",
                          submit: _vm.onOutboundWeightFeeSubmitted
                        },
                        model: {
                          value: _vm.isShowOutboundWeightFeeSettingPopup,
                          callback: function($$v) {
                            _vm.isShowOutboundWeightFeeSettingPopup = $$v
                          },
                          expression: "isShowOutboundWeightFeeSettingPopup"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isHasDropshippingOrg || !_vm.isTenant
        ? _c(
            "div",
            [
              _c("v-layout", { staticClass: "headline mt-5" }, [
                _vm._v(_vm._s(_vm.$t("outboundPkgMaterialFeeForDropshipping")))
              ]),
              _vm._v(" "),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "add",
                          attrs: { dark: "", color: "primary" },
                          on: { click: _vm.showMaterialFeePopup }
                        },
                        [_vm._v(_vm._s(_vm.$t("edit")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-container",
                                    {
                                      attrs: { fluid: "", "grid-list-lg": "" }
                                    },
                                    _vm._l(_vm.materialFees, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "v-layout",
                                        {
                                          key: index,
                                          attrs: { "justify-space-between": "" }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass:
                                                "text-xs-right title",
                                              attrs: { md4: "" }
                                            },
                                            [_vm._v(_vm._s(item.name))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-xs-right",
                                              attrs: { md3: "" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("price")) + ": "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-xs-left",
                                              attrs: { md1: "" }
                                            },
                                            [
                                              _vm._v(
                                                "$ " + _vm._s(item.price || 0)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("v-flex", {
                                            staticClass: "text-xs-left",
                                            attrs: { md4: "" }
                                          })
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isShowMaterialFeePopup
                    ? _c("FormSubmitPopup", {
                        attrs: {
                          title: _vm.$t("editMaterialFeeRates"),
                          rightMethod: _vm.updateMaterialFees,
                          medium: ""
                        },
                        on: { popupClose: _vm.resetMaterialFeeForm },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "input",
                              fn: function() {
                                return [
                                  _c(
                                    "v-container",
                                    [
                                      _vm._l(_vm.materialFeesInEdit, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "v-layout",
                                          {
                                            key: index,
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { md5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        _vm.$t("name")
                                                      ),
                                                      _vm.validateUniqueMaterialFee(
                                                        _vm.$t("name")
                                                      )
                                                    ],
                                                    label: _vm.$t("name"),
                                                    required: ""
                                                  },
                                                  model: {
                                                    value: item.name,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "name",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "item.name"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { md5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    rules: [
                                                      _vm.fieldIsRequired(),
                                                      _vm.fieldIsNoLessThanZero(),
                                                      _vm.fieldIsNumber()
                                                    ],
                                                    label: _vm.$t("price"),
                                                    required: "",
                                                    prefix: "$"
                                                  },
                                                  model: {
                                                    value: item.price,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "price",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression: "item.price"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: { md1: "", "mt-3": "" }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: { icon: "" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deleteMaterialFee(
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("delete")
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: { "justify-space-between": "" }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { color: "primary" },
                                              on: {
                                                click: _vm.addNewMaterialFee
                                              }
                                            },
                                            [
                                              _c("v-icon", [_vm._v("add")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("add")) +
                                                  " "
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          1663986650
                        ),
                        model: {
                          value: _vm.isShowMaterialFeePopup,
                          callback: function($$v) {
                            _vm.isShowMaterialFeePopup = $$v
                          },
                          expression: "isShowMaterialFeePopup"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-layout", { attrs: { headline: "", "mt-5": "" } }, [
        _vm._v(_vm._s(_vm.$t("publicOtherServiceRates")))
      ]),
      _vm._v(" "),
      !_vm.displayMode
        ? _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { md2: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "edit",
                      attrs: { color: "primary" },
                      on: { click: _vm.showBillingOtherRatesDialog }
                    },
                    [_vm._v(_vm._s(_vm.$t("edit")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "", "grid-list-lg": "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("measureDimension")) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(
                                        _vm.otherRates.measureDimensionFee || 0
                                      )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("expeditePackage")) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(_vm.otherRates.expeditePackageFee)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [_vm._v(_vm._s(_vm.$t("oversizedFee")) + ": ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(_vm.otherRates.oversizedFee || 0)
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [_vm._v(_vm._s(_vm.$t("itemPhotoFee")) + ": ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(_vm.otherRates.itemPhotoFee || 0)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("packageConsolidationFee")) +
                                      ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(
                                        _vm.otherRates
                                          .packageConsolidationFee || 0
                                      )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("packageReinforcementFee")) +
                                      ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(
                                        _vm.otherRates
                                          .packageReinforcementFee || 0
                                      )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c("v-flex", { attrs: { md1: "" } }),
                              _vm._v(" "),
                              _c("h3", [_vm._v(_vm._s(_vm.$t("label")))])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("smallItemLabelPerUnit"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(_vm.otherRates.smallItemLabelFee)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("mediumItemLabelPerUnit"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(_vm.otherRates.mediumItemLabelFee)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("largeItemLabelPerUnit"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(_vm.otherRates.largeItemLabelFee)
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("itemLabelPerUnit", {
                                        type: _vm.$t("custom")
                                      })
                                    ) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(
                                        _vm.otherRates.customItemLabelFee || 0
                                      )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("itemLabelPerUnit", {
                                        type: _vm.$t("nonOpenBox")
                                      })
                                    ) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(
                                        _vm.otherRates.nonOpenBoxItemLabelFee ||
                                          0
                                      )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-flex", {
                                staticClass: "text-xs-right",
                                attrs: { md3: "" }
                              }),
                              _vm._v(" "),
                              _c("v-flex", {
                                staticClass: "text-xs-left",
                                attrs: { md1: "" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c("v-flex", { attrs: { md1: "" } }),
                              _vm._v(" "),
                              _c("h3", [_vm._v("SN")])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("smallItemSNPerUnit")) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " + _vm._s(_vm.otherRates.smallItemSNFee)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("mediumItemSNPerUnit")) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(_vm.otherRates.mediumItemSNFee)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("largeItemSNPerUnit")) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " + _vm._s(_vm.otherRates.largeItemSNFee)
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("itemSnPerUnit", {
                                        type: _vm.$t("custom")
                                      })
                                    ) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(
                                        _vm.otherRates.customItemSNFee || 0
                                      )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("itemSnPerUnit", {
                                        type: _vm.$t("nonOpenBox")
                                      })
                                    ) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(
                                        _vm.otherRates.nonOpenBoxItemSNFee || 0
                                      )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { md4: "" } })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("smallItemPhoto")) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(_vm.otherRates.smallItemPhotoFee)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("mediumItemPhoto")) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(_vm.otherRates.mediumItemPhotoFee)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("largeItemPhoto")) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(_vm.otherRates.largeItemPhotoFee)
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("quantityPerSmallItemPhoto")
                                    ) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.otherRates.smallItemPhotoQuantity
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("quantityPerMediumItemPhoto")
                                    ) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.otherRates.mediumItemPhotoQuantity
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("quantityPerLargeItemPhoto")
                                    ) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.otherRates.largeItemPhotoQuantity
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("itemPhotoPerUnit", {
                                        type: _vm.$t("nonOpenBox")
                                      })
                                    ) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(
                                        _vm.otherRates.nonOpenBoxItemPhotoFee ||
                                          0
                                      )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("itemPhotoPerUnit", {
                                        type: _vm.$t("custom")
                                      })
                                    ) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(
                                        _vm.otherRates.customItemPhotoFee || 0
                                      )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-flex", {
                                staticClass: "text-xs-right",
                                attrs: { md3: "" }
                              }),
                              _vm._v(" "),
                              _c("v-flex", {
                                staticClass: "text-xs-left",
                                attrs: { md1: "" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("quantityPerItemPhoto", {
                                        type: _vm.$t("nonOpenBox")
                                      })
                                    ) + ":\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.otherRates.nonOpenBoxItemPhotoQuantity
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { md3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("quantityPerItemPhoto", {
                                        type: _vm.$t("custom")
                                      })
                                    ) + ": "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-left",
                                  attrs: { md1: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.otherRates.customItemPhotoQuantity
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-flex", {
                                staticClass: "text-xs-right",
                                attrs: { md3: "" }
                              }),
                              _vm._v(" "),
                              _c("v-flex", {
                                staticClass: "text-xs-left",
                                attrs: { md1: "" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.baseBillingRatesDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("editBaseBillingRates"),
              large: "",
              rightMethod: _vm.onBaseRatesChangeSubmitted,
              rightButtonText: _vm.$t("submit")
            },
            on: {
              popupClose: function($event) {
                _vm.baseBillingRatesDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-container",
                        [
                          _vm._l(
                            _vm.ratesInEdit.unitRates.slice(0, 3),
                            function(item) {
                              return _c(
                                "v-layout",
                                {
                                  key: item.sortKey,
                                  attrs: {
                                    "justify-space-between": "",
                                    "align-center": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "subheading",
                                      attrs: { md2: "" }
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { md2: "" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "required_field",
                                        attrs: {
                                          label: _vm.$t("inboundPerPackage"),
                                          prefix: "$",
                                          rules: [
                                            _vm.fieldIsRequired(),
                                            _vm.fieldIsNoLessThanZero(),
                                            _vm.fieldIsNumber()
                                          ]
                                        },
                                        model: {
                                          value: item.packageInbound,
                                          callback: function($$v) {
                                            _vm.$set(
                                              item,
                                              "packageInbound",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "item.packageInbound"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { md2: "" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "required_field",
                                        attrs: {
                                          label: _vm.$t("inboundPerUnit"),
                                          prefix: "$",
                                          rules: [
                                            _vm.fieldIsRequired(),
                                            _vm.fieldIsNoLessThanZero(),
                                            _vm.fieldIsNumber()
                                          ]
                                        },
                                        model: {
                                          value: item.inbound,
                                          callback: function($$v) {
                                            _vm.$set(
                                              item,
                                              "inbound",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "item.inbound"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { md2: "" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "required_field",
                                        attrs: {
                                          label: _vm.$t("outboundPerPackage"),
                                          prefix: "$",
                                          rules: [
                                            _vm.fieldIsRequired(),
                                            _vm.fieldIsNoLessThanZero(),
                                            _vm.fieldIsNumber()
                                          ]
                                        },
                                        model: {
                                          value: item.packageOutbound,
                                          callback: function($$v) {
                                            _vm.$set(
                                              item,
                                              "packageOutbound",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "item.packageOutbound"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { md2: "" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "required_field",
                                        attrs: {
                                          label: _vm.$t("outboundPerUnit"),
                                          prefix: "$",
                                          rules: [
                                            _vm.fieldIsRequired(),
                                            _vm.fieldIsNoLessThanZero(),
                                            _vm.fieldIsNumber()
                                          ]
                                        },
                                        model: {
                                          value: item.outbound,
                                          callback: function($$v) {
                                            _vm.$set(
                                              item,
                                              "outbound",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "item.outbound"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { md2: "" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "required_field",
                                        attrs: {
                                          label: _vm.$t("storageDaily"),
                                          prefix: "$",
                                          rules: [
                                            _vm.fieldIsRequired(),
                                            _vm.fieldIsNoLessThanZero(),
                                            _vm.fieldIsNumber()
                                          ]
                                        },
                                        model: {
                                          value: item.storage,
                                          callback: function($$v) {
                                            _vm.$set(
                                              item,
                                              "storage",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "item.storage"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { md2: "" } })
                                ],
                                1
                              )
                            }
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.addedLevelRatesInEdit, function(item) {
                            return _c(
                              "v-layout",
                              {
                                key: item.sortKey,
                                attrs: { "justify-space-between": "" }
                              },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { md2: "" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "required_field",
                                      attrs: {
                                        label: _vm.$t("name"),
                                        rules: [
                                          _vm.fieldIsRequired(),
                                          function(val) {
                                            return (
                                              _vm.nameMap.get(val) <= 1 ||
                                              _vm.$t("nameCanNotBeDuplicated")
                                            )
                                          }
                                        ]
                                      },
                                      model: {
                                        value: item.name,
                                        callback: function($$v) {
                                          _vm.$set(
                                            item,
                                            "name",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { md2: "" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "required_field",
                                      attrs: {
                                        label: _vm.$t("inboundPerPackage"),
                                        prefix: "$",
                                        rules: [
                                          _vm.fieldIsRequired(),
                                          _vm.fieldIsNoLessThanZero(),
                                          _vm.fieldIsNumber()
                                        ]
                                      },
                                      model: {
                                        value: item.packageInbound,
                                        callback: function($$v) {
                                          _vm.$set(
                                            item,
                                            "packageInbound",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.packageInbound"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { md2: "" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "required_field",
                                      attrs: {
                                        label: _vm.$t("inboundPerUnit") + ":",
                                        prefix: "$",
                                        rules: [
                                          _vm.fieldIsRequired(),
                                          _vm.fieldIsNoLessThanZero(),
                                          _vm.fieldIsNumber()
                                        ]
                                      },
                                      model: {
                                        value: item.inbound,
                                        callback: function($$v) {
                                          _vm.$set(item, "inbound", _vm._n($$v))
                                        },
                                        expression: "item.inbound"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { md2: "" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "required_field",
                                      attrs: {
                                        label: _vm.$t("outboundPerPackage"),
                                        prefix: "$",
                                        rules: [
                                          _vm.fieldIsRequired(),
                                          _vm.fieldIsNoLessThanZero(),
                                          _vm.fieldIsNumber()
                                        ]
                                      },
                                      model: {
                                        value: item.packageOutbound,
                                        callback: function($$v) {
                                          _vm.$set(
                                            item,
                                            "packageOutbound",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.packageOutbound"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { md2: "" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "required_field",
                                      attrs: {
                                        label: _vm.$t("outboundPerUnit") + ":",
                                        prefix: "$",
                                        rules: [
                                          _vm.fieldIsRequired(),
                                          _vm.fieldIsNoLessThanZero(),
                                          _vm.fieldIsNumber()
                                        ]
                                      },
                                      model: {
                                        value: item.outbound,
                                        callback: function($$v) {
                                          _vm.$set(
                                            item,
                                            "outbound",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.outbound"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { md2: "" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "required_field",
                                      attrs: {
                                        label: _vm.$t("storageDaily") + ":",
                                        prefix: "$",
                                        rules: [
                                          _vm.fieldIsRequired(),
                                          _vm.fieldIsNoLessThanZero(),
                                          _vm.fieldIsNumber()
                                        ]
                                      },
                                      model: {
                                        value: item.storage,
                                        callback: function($$v) {
                                          _vm.$set(item, "storage", _vm._n($$v))
                                        },
                                        expression: "item.storage"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { md2: "" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          color: "red",
                                          icon: "",
                                          flat: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.deleteNewRateLevel(item)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", { attrs: { dark: "" } }, [
                                          _vm._v("cancel")
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary" },
                                  on: { click: _vm.addNewRateLevel }
                                },
                                [
                                  _c("v-icon", [_vm._v("add")]),
                                  _vm._v(" " + _vm._s(_vm.$t("level")) + " ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1287799125
            ),
            model: {
              value: _vm.baseBillingRatesDialog,
              callback: function($$v) {
                _vm.baseBillingRatesDialog = $$v
              },
              expression: "baseBillingRatesDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.otherServiceBillingRatesDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("editOtherServiceBillingRates"),
              large: "",
              rightMethod: _vm.onOtherServiceRatesChangeSubmitted,
              rightButtonText: _vm.$t("submit")
            },
            on: {
              popupClose: function($event) {
                _vm.otherServiceBillingRatesDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("measureDimension"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit
                                          .measureDimensionFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "measureDimensionFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.measureDimensionFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("expeditePackageFee"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit.expeditePackageFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "expeditePackageFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.expeditePackageFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("oversizedFee"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value: _vm.otherRatesInEdit.oversizedFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "oversizedFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.oversizedFee"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("itemPhotoFee"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value: _vm.otherRatesInEdit.itemPhotoFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "itemPhotoFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.itemPhotoFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("packageConsolidationFee"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit
                                          .packageConsolidationFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "packageConsolidationFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.packageConsolidationFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("packageReinforcementFee"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit
                                          .packageReinforcementFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "packageReinforcementFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.packageReinforcementFee"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("h3", [_vm._v(_vm._s(_vm.$t("label")))]),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("smallItemLabelPerUnit"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit.smallItemLabelFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "smallItemLabelFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.smallItemLabelFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("mediumItemLabelPerUnit"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit.mediumItemLabelFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "mediumItemLabelFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.mediumItemLabelFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("largeItemLabelPerUnit"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit.largeItemLabelFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "largeItemLabelFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.largeItemLabelFee"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("itemLabelPerUnit", {
                                        type: _vm.$t("custom")
                                      }),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit.customItemLabelFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "customItemLabelFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.customItemLabelFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("itemLabelPerUnit", {
                                        type: _vm.$t("nonOpenBox")
                                      }),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit
                                          .nonOpenBoxItemLabelFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "nonOpenBoxItemLabelFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.nonOpenBoxItemLabelFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { md3: "" } })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("h3", [_vm._v("SN")]),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("smallItemSNPerUnit"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit.smallItemSNFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "smallItemSNFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.smallItemSNFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("mediumItemSNPerUnit"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit.mediumItemSNFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "mediumItemSNFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.mediumItemSNFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("largeItemSNPerUnit"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit.largeItemSNFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "largeItemSNFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.largeItemSNFee"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("itemSnPerUnit", {
                                        type: _vm.$t("custom")
                                      }),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit.customItemSNFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "customItemSNFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.customItemSNFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("itemSnPerUnit", {
                                        type: _vm.$t("nonOpenBox")
                                      }),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit
                                          .nonOpenBoxItemSNFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "nonOpenBoxItemSNFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.nonOpenBoxItemSNFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { md3: "" } })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("smallItemPhotoFee"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit.smallItemPhotoFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "smallItemPhotoFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.smallItemPhotoFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("mediumItemPhotoFee"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit.mediumItemPhotoFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "mediumItemPhotoFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.mediumItemPhotoFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("largeItemPhotoFee"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit.largeItemPhotoFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "largeItemPhotoFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.largeItemPhotoFee"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t(
                                        "quantityPerSmallItemPhoto"
                                      ),
                                      prefix: "#",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit
                                          .smallItemPhotoQuantity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "smallItemPhotoQuantity",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.smallItemPhotoQuantity"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t(
                                        "quantityPerMediumItemPhoto"
                                      ),
                                      prefix: "#",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit
                                          .mediumItemPhotoQuantity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "mediumItemPhotoQuantity",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.mediumItemPhotoQuantity"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t(
                                        "quantityPerLargeItemPhoto"
                                      ),
                                      prefix: "#",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit
                                          .largeItemPhotoQuantity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "largeItemPhotoQuantity",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.largeItemPhotoQuantity"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("itemPhotoPerUnit", {
                                        type: _vm.$t("nonOpenBox")
                                      }),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit
                                          .nonOpenBoxItemPhotoFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "nonOpenBoxItemPhotoFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.nonOpenBoxItemPhotoFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("itemPhotoPerUnit", {
                                        type: _vm.$t("custom")
                                      }),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit.customItemPhotoFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "customItemPhotoFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.customItemPhotoFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { md3: "" } })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("quantityPerItemPhoto", {
                                        type: _vm.$t("nonOpenBox")
                                      }),
                                      prefix: "#",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit
                                          .nonOpenBoxItemPhotoQuantity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "nonOpenBoxItemPhotoQuantity",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.nonOpenBoxItemPhotoQuantity"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("quantityPerItemPhoto", {
                                        type: _vm.$t("custom")
                                      }),
                                      prefix: "#",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.otherRatesInEdit
                                          .customItemPhotoQuantity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherRatesInEdit,
                                          "customItemPhotoQuantity",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "otherRatesInEdit.customItemPhotoQuantity"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { md3: "" } })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2417569372
            ),
            model: {
              value: _vm.otherServiceBillingRatesDialog,
              callback: function($$v) {
                _vm.otherServiceBillingRatesDialog = $$v
              },
              expression: "otherServiceBillingRatesDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editDiscountDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("discount"),
              rightMethod: _vm.editDiscount,
              rightButtonText: _vm.$t("submit")
            },
            on: {
              popupClose: function($event) {
                _vm.editDiscountDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-layout",
                            { attrs: { "justify-center": "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("name"),
                                      rules: [
                                        _vm.fieldIsRequired("Name"),
                                        _vm.fieldCheckDup("name")
                                      ]
                                    },
                                    model: {
                                      value: _vm.discountInEdit.name,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.discountInEdit,
                                          "name",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "discountInEdit.name"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-center": "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("threshold"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired("Threshold"),
                                        _vm.fieldIsNumber("Threshold"),
                                        _vm.fieldCheckDup("threshold")
                                      ]
                                    },
                                    model: {
                                      value: _vm.discountInEdit.threshold,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.discountInEdit,
                                          "threshold",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "discountInEdit.threshold"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-center": "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("off"),
                                      suffix: "%",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ],
                                      hint: "Hint: 0-100"
                                    },
                                    model: {
                                      value: _vm.discountInEdit.discountRate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.discountInEdit,
                                          "discountRate",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "discountInEdit.discountRate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3333234148
            ),
            model: {
              value: _vm.editDiscountDialog,
              callback: function($$v) {
                _vm.editDiscountDialog = $$v
              },
              expression: "editDiscountDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.baseBillingForecastRatesDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("editForecastBaseBillingRates"),
              large: "",
              rightMethod: _vm.onForecastBaseRatesChangeSubmitted,
              rightButtonText: _vm.$t("submit")
            },
            on: {
              popupClose: function($event) {
                _vm.baseBillingForecastRatesDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "", row: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("inboundPerPackage"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.forecastRatesInEdit.packageInbound,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.forecastRatesInEdit,
                                          "packageInbound",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "forecastRatesInEdit.packageInbound"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("outboundPerPackage"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.forecastRatesInEdit.packageOutbound,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.forecastRatesInEdit,
                                          "packageOutbound",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "forecastRatesInEdit.packageOutbound"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("dailyStoragePerUnit"),
                                      prefix: "$",
                                      hint: _vm.$t("unitCubicInchHint"),
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value: _vm.forecastRatesInEdit.storage,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.forecastRatesInEdit,
                                          "storage",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "forecastRatesInEdit.storage"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { md3: "" } })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "", row: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("unitFee"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value: _vm.forecastRatesInEdit.unitFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.forecastRatesInEdit,
                                          "unitFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "forecastRatesInEdit.unitFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      label: _vm.$t("unpackingMinimumFee"),
                                      prefix: "$",
                                      rules: [
                                        _vm.fieldIsRequired(),
                                        _vm.fieldIsNoLessThanZero(),
                                        _vm.fieldIsNumber()
                                      ]
                                    },
                                    model: {
                                      value:
                                        _vm.forecastRatesInEdit
                                          .unpackingMinimumFee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.forecastRatesInEdit,
                                          "unpackingMinimumFee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "forecastRatesInEdit.unpackingMinimumFee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { md6: "" } })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3174133492
            ),
            model: {
              value: _vm.baseBillingForecastRatesDialog,
              callback: function($$v) {
                _vm.baseBillingForecastRatesDialog = $$v
              },
              expression: "baseBillingForecastRatesDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8b45a84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8b45a84","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BillingSettings.vue
// module id = null
// module chunks = 